import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { ServerTypes } from 'src/app/models/servers';
import { Observable, BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';

export interface VrmRegexModel {
  countryCode: string;
  regex: string;
  format: string;
  countryId: number;
}

const vrmRegexUrl = '/v1/system/vrmregex';

@Injectable({ providedIn: 'root' })
export class VrmRegexService {
  private vrmRegexModels = new BehaviorSubject<VrmRegexModel[]>([]);
  vrmRegexModels$: Observable<
    VrmRegexModel[]
  > = this.vrmRegexModels.asObservable();

  constructor(private apiService: ApiService, private httpClient: HttpClient) {
    this.getAll()
      .pipe(first())
      .subscribe((result) => {
        this.vrmRegexModels.next(result);
      });
  }

  private getAll(): Observable<VrmRegexModel[]> {
    const server = this.apiService.getCurentServer(ServerTypes.boapi);
    const url = `${server}/${vrmRegexUrl}`;

    return this.httpClient.get<VrmRegexModel[]>(url);
  }
}
